import { getAssetNumberValue, getFleetAssetValidation } from "./AssetNumberAction";

const dispatchGetAssetNumberValue = (dispatch: Function) => (val : any) => {
    dispatch(getAssetNumberValue(val));
};

const dispatchGetFleetAssetValidation = (dispatch: Function) => (val : any) => {
    dispatch(getFleetAssetValidation(val));
};

const AssetNumberDispatch = {
    dispatchGetAssetNumberValue,
    dispatchGetFleetAssetValidation
};

export default AssetNumberDispatch